<template>
  <v-list-item v-if="!isEditing" avatar ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-handshake-alt'" :note="printNote" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">当センターへの目的</v-list-item-subtitle>
      <v-list-item-title v-if="isPrintEmpty">当センターへの目的</v-list-item-title>
      <v-list-item-title v-else-if="isNoAnswer">回答なし</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getWantLabelItems" :key="idx" class="caption grey lighten-2 pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>当センターへの目的</v-subheader>
    <v-row dense justify="end">
      <div class="text-xs-right">
        <v-switch color="blue darken-2" label="回答なし" v-model="config.ignore" @change="ignore"></v-switch>
      </div>
    </v-row>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" class="px-3">
        <span class="caption">目的の選択</span>
        <v-chip-group multiple column
          active-class="secondary white--text"
          v-model="form.wants.content">
          <v-chip
            v-for="item in getWantItems"
            :key="`wants_content_${item.value}`"
            :value="item.value"
            :rules="rules.wants">{{ item.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.wants.note"
          label="当センター目的の備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutSurveyKnows',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false
      },
      meta: {
        wants: {
          unclear: '漠然と考えているので話を聞きたい',
          information: '知りたいことがある',
          estimate: '見積もりが欲しい',
          research: '調べてほしいことがある',
          contract: '契約/依頼をしたい',
          other: 'その他'
        }
      },
      form: {
        wants: {
          id: '',
          content: [],
          note: ''
        }
      },
      rules: {
        wants: [
          v => !!(v && v.length) || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.wants
      ) {
        this.$set(this.config, 'ignore', !!(this.$props.data.wants.content && this.$props.data.wants.content === 'NONE'))
        this.$set(this.form, 'wants', {
          id: '' + (this.$props.data.wants.id ? this.$props.data.wants.id : 'new_wants'),
          content: this.$props.data.wants.content ? this.$props.data.wants.content.split(',') : [],
          note: this.$props.data.wants.note ? this.$props.data.wants.note : ''
        })
      } else {
        this.$set(this.form, 'wants', {
          id: 'new_wants',
          content: [],
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'wants'
        }
      })
    },
    ignore: function () {
      this.$set(this.form.wants, 'content', this.config.ignore ? ['NONE'] : [])
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['wants', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'wants'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['wants', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'wants'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.wants &&
        this.$props.data.wants.content &&
        this.$props.data.wants.content === 'NONE'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.wants &&
        this.$props.data.wants.content
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.wants &&
        this.$props.data.wants.note
      ) ? this.$props.data.wants.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.wants &&
        this.$props.data.wants.note
      )
    },
    getWantItems () {
      return Object.keys(this.meta.wants).map(key => {
        return {
          text: this.meta.wants[key],
          value: key
        }
      })
    },
    getWantLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.wants &&
        this.$props.data.wants.content
      ) ? this.$props.data.wants.content.split(',').map(key => {
          return (this.meta.wants[key]) ? this.meta.wants[key] : ''
        }) : []
    }
  }
}
</script>
